<template>
      <div class="home">
          <el-carousel indicator-position="none">
              <el-carousel-item v-for="img in bgImags" :key="img.id" >
                  <!-- <img src="../assets/homeNew/home_banner.png" width="100%"> -->
                  <img :src="`${baseUrl}rest/api/sftp/show?path=${img.filePath}`" width="100%">
              </el-carousel-item>
          </el-carousel>
          <div class="container-center">
              <!-- <div class="notice-box">
                  <div class="notice-box-title">大华集团公告</div>
                  <div class="notice-box-content" v-for="content in groupContent" :key="content.id" @click="toDetail(content)">
                      <span class="notice-box-text">{{ content.title }}</span>
                      <span class="notice-box-date">{{ content.issueDate }}</span>
                  </div> -->
                  <!-- <div class="notice-box-content">
                      <span class="notice-box-text">【技术标不合格】江苏省江南建筑技术发展总公司</span>
                      <span class="notice-box-date">2020-07-03</span>
                  </div> -->
                  <!-- <div class="notice-box-btn">
                      <div class="home-btn" @click="$router.push('/notice')">More</div>
                  </div>
              </div> -->
                <div class="notice-box-wrap">
                    <div class="bid-box">
                        <div class="rank-box-top">
                            <div class="rank-left-box">
                                <i class="iconfont icon-gonggao"></i>
                                <span class="title-text">大华集团公告</span>
                            </div>
                            <div class="home-btn right-btn" @click="$router.push('/notice')">More</div>
                        </div>
                        <div class="notice-box-container">
                            <div v-for="content in groupContent"  :key="content.id" @click="toDetail(content)" class="notice-item">
                                <span class="notice-box-text">{{ content.title }}</span>
                                <span class="notice-box-date">{{ content.issueDate }}</span>
                            </div>
                        </div>
                    </div>
                </div>


              <!--招标、中标公告-->
              <div class="bid-box">
                  <div class="bid-img-box img-left">
                      <div class="img-box-text">招标公告</div>
                      <div class="img-box-btn">
                          <div class="home-btn" @click="$router.push('/inviteList')">More</div>
                      </div>
                  </div>
                  <div class="bid-content-left">
                      <div class="bid-content-row" style="width: 500px" v-for="invite in inviteList" :key="invite.fid">
                          <span class="label-tip">{{ invite.productTypeName || '无限制' }}</span>
                          <span class="content-text-invite" @click="showInfoDetail(invite)" :title="invite.fname">{{ invite.fname }}</span>
                          <span class="content-date">{{ invite.finvregisteddeadline | date }} 报名截止</span>
                      </div>
                      <!-- <div class="bid-content-row" style="width: 500px">
                          <span class="label-tip">标识系统工程</span>
                          <span class="content-text">星河项目4、5地块一期二组团标识系统工程</span>
                          <span class="content-date">2020-07-06 截止</span>
                      </div>
                      <div class="bid-content-row" style="width: 500px">
                          <span class="label-tip">标识系统工程</span>
                          <span class="content-text">星河项目4、5地块一期二组团标识系统工程</span>
                          <span class="content-date">2020-07-06 截止</span>
                      </div>
                      <div class="bid-content-row" style="width: 500px">
                          <span class="label-tip">标识系统工程</span>
                          <span class="content-text">星河项目4、5地块一期二组团标识系统工程</span>
                          <span class="content-date">2020-07-06 截止</span>
                      </div>
                      <div class="bid-content-row" style="width: 500px">
                          <span class="label-tip">标识系统工程</span>
                          <span class="content-text">星河项目4、5地块一期二组团标识系统工程</span>
                          <span class="content-date">2020-07-06 截止</span>
                      </div> -->
                  </div>
                  <div class="bid-img-box img-right">
                      <div class="img-box-text">中标公告</div>
                      <div class="img-box-btn">
                          <div class="home-btn" @click="$router.push('/winList')">More</div>
                      </div>
                  </div>
                  <div class="bid-content-right">
                      <div class="bid-content-row" style="width: 394px" v-for="win in wininviteList" :key="win.id">
                          <span class="label-tip2">中标</span>
                          <span class="content-text" @click="$router.push('/WinDetail/'+encodeURIComponent(win.inviteProjectId)+'?isWin=1')" :title="win.supplierName">{{ win.supplierName }}</span>
                          <span class="content-right-text">{{ win.projectName }}</span>
                      </div>
                      <!-- <div class="bid-content-row" style="width: 394px">
                          <span class="label-tip2">中标</span>
                          <span class="content-text">上海雄达阔业投资咨询有限公司</span>
                          <span class="content-right-text">星河项目4、5地块一期二组团标识系统工程</span>
                      </div> -->
                  </div>
              </div>
              <!--年度优良供方-->
              <div class="rank-box">
                  <div class="rank-box-top">
                      <div class="rank-left-box">
                          <i class="iconfont icon-paiming"></i>
                          <span class="title-text">年度优良供方</span>
                      </div>
                      <div class="rank-left-box" style="margin-top: 5px">
                          <el-popover
                              placement="bottom"
                              width="100"
                              ref="yearpop"
                              trigger="click">
                              <div slot="reference" class="select-box-div">
                                  <span>{{ nowYear }}</span><i class="iconfont icon-icon-down"></i>
                              </div>
                              <div class="select-year-box">
                                  <div v-for="item in chooseYears" :key="item" :class="`select-year-item${item == nowYear ? ' active' : ''}`" @click="selYear(item)">{{ item }}</div>
                              </div>
                          </el-popover>
                      </div>
                      <div class="home-btn right-btn" @click="$router.push('/sysYearList')">More</div>
                  </div>
                  <div class="rank-box-main" v-if="yearType == '2'">
                      <el-carousel height="468px" :autoplay="false" arrow="never" trigger="click" indicator-position="outside">
                          <el-carousel-item v-for="(item, index) in homeYearList" :key="index">
                              <el-row :gutter="30">
                                  <el-col :span="8" v-for="(obj, tempI) in item" :key="tempI">
                                      <div class="main-row-box">
                                          <div :class="`main-row-top topBg_${tempI + 1}`">
                                              <div class="top-text-box">{{ obj.productName }}</div>
                                          </div>
                                          <div class="main-row-middle">
                                              <div class="middle-row" v-for="(tempOne, oneI) in obj.detailList" :key="oneI">
                                                  <div class="left-div">
                                                      <i class="iconfont icon-paiming"></i>
                                                      <span class="middle-row-text">{{ tempOne.supplierName }}</span>
                                                  </div>
                                                  <div class="right-div active">{{ tempOne.evaluateLevel }}</div>
                                              </div>
                                          </div>
                                      </div>
                                  </el-col>
                              </el-row>
                          </el-carousel-item>
                      </el-carousel>
                  </div>

                  <div class="rank-box-main2" v-if="yearType == '1'">
                      <el-tabs v-model="activeName" @tab-click="handleClick">
                          <el-tab-pane v-for="(item, index) in homeYearList" :key="index" :label="item.productName" :name="index + ''">
                              <el-row :gutter="40">
                                  <el-col :span="8" class="main-row-middle rank-col-8">
                                      <div class="middle-row" v-if="!!item.detailList[0]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[0].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[0].evaluateLevel }}</div>
                                      </div>
                                      <div class="middle-row" v-if="!!item.detailList[1]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[1].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[1].evaluateLevel }}</div>
                                      </div>
                                      <div class="middle-row" v-if="!!item.detailList[2]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[2].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[2].evaluateLevel }}</div>
                                      </div>
                                  </el-col>
                                  <el-col :span="8" class="main-row-middle rank-col-8">
                                      <div class="middle-row" v-if="!!item.detailList[3]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[3].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[3].evaluateLevel }}</div>
                                      </div>
                                      <div class="middle-row" v-if="!!item.detailList[4]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[4].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[4].evaluateLevel }}</div>
                                      </div>
                                      <div class="middle-row" v-if="!!item.detailList[5]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[5].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[5].evaluateLevel }}</div>
                                      </div>
                                  </el-col>
                                  <el-col :span="8" class="main-row-middle rank-col-8">
                                      <div class="middle-row" v-if="!!item.detailList[6]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[6].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[6].evaluateLevel }}</div>
                                      </div>
                                      <div class="middle-row" v-if="!!item.detailList[7]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[7].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[7].evaluateLevel }}</div>
                                      </div>
                                      <div class="middle-row" v-if="!!item.detailList[8]">
                                          <div class="left-div">
                                              <i class="iconfont icon-paiming"></i>
                                              <span class="middle-row-text">{{ item.detailList[8].supplierName }}</span>
                                          </div>
                                          <div class="right-div active">{{ item.detailList[8].evaluateLevel }}</div>
                                      </div>
                                  </el-col>
                              </el-row>
                          </el-tab-pane>
                      </el-tabs>
                  </div>
              </div>
              
              <!--供方履约公告-->
              <div class="rank-box">
                  <div class="rank-box-top">
                      <div class="rank-left-box">
                          <i class="iconfont icon-gonggao"></i>
                          <span class="title-text">供方履约公告</span>
                      </div>
                      <div class="home-btn right-btn" @click="$router.push('/peSupplierList')">More</div>
                  </div>
                  <div class="supplier-box-main">
                      <div class="left-box" v-if="!!peList && peList.length > 0">
                          <div class="content-div" @click="$router.push('/performanceSupplierNoticeInfo/'+ peList[0].id)">
                              <span>{{ peList[0].title }}</span>
                              <i class="iconfont icon-icon_more"></i>
                          </div>
                      </div>
                      <el-row :gutter="16" class="right-box">
                          <el-col :span="12">
                              <div class="right-box-item" v-for="(item, index) in peList" :key="index" @click="$router.push('/performanceSupplierNoticeInfo/'+ item.id)">
                                  <div class="item-left">
                                      <div class="num-box-1">{{ index + 1 }}</div>
                                      <div class="num-box-line"></div>
                                      <div class="num-box-2">{{ item.updateDate | date }}</div>
                                  </div>
                                  <div class="item-right">
                                      <div class="content-text-box">{{ item.title }}</div>
                                      <div class="icon-icon_more_icon"><i class="iconfont icon-icon_more"></i></div>
                                  </div>
                              </div>
                          </el-col>
                      </el-row>
                  </div>
              </div>
          </div>
      </div>
</template>

<script type="text/babel">
import filter from '@/filter'
import util from '@/util'
export default {
    name: 'index',
    filters: filter,
    data () {
        return {
            baseUrl: util.baseUrl,
            activeName: '0',
            bgImags: [],
            inviteList: [],
            wininviteList: [],
            groupContent: [],
            nowYear: null,
            homeYearList: [],
            chooseYears: [],
            yearType: '',
            peList: []
        }
    },
    methods: {
        handleClick(val){
            this.activeName = val.name;
        },
        /*获取轮播图*/
        getCarousel(){
            this.$http.post('/rest/api/bg/img/list', {
                    type: 0
                }
            ).then((res)=>{
                if(res.data.result) {
                    this.bgImags = res.data.value;
                }
            } , err => {
                this.$alert(err)
            })
        },
        /*获取招标公告*/
        getInviteList(){
            this.$http.post('/rest/api/invite/project/list',{
                "pageNum": 1,
                "pageSize": 5,
                supplierId: this.$root.stockId
            }).then((res)=>{
                if(res.data.result) {
                    this.inviteList = res.data.value.list;
                }
            } , err => {
                this.$alert(err)
            })
        },
        /*获取中标公告*/
        getWinInviteList(){
            this.$http.post('/rest/api/project/inquiry/winInfo', {
                'pageNum': 1,
                'pageSize': 5,
				'projectName': '',
				'signBeginTime': '',
				'signEndTime': ''
            }).then((res) => {
                if(res.data.result) {
                    this.wininviteList = res.data.value.list;
                }
            } , err => {
                this.$alert(err)
            })
        },
        /*获取集团公告*/
        getGroupContent(){
            this.$http.post('/rest/api/group/content/indexList').then((res)=>{
                if(res.data.result) {
                    this.groupContent = res.data.value;
                }
                this.$root.loading = false;
            } , err => {
                this.$root.loading = false;
                this.$alert(err)
            })
        },
        /*获取首页年度优良供方*/
        getHomeYear () {
            this.$http.get(`/rest/api/supplierHomepage/getHomeYear/${this.nowYear}`).then((res)=>{
                if (res.data.result) {
                    this.homeYearList = res.data.value.list
                    
                    this.homeYearList.forEach(item => {
                        let tempArray = item.productName.split('_')
                        item.productName = tempArray[tempArray.length - 1]
                    })

                    this.nowYear = res.data.value.nowYear
                    this.chooseYears = res.data.value.chooseYears
                    this.yearType = res.data.value.type

                    if (this.yearType == '2') {
                        // 如果是卡片形式
                        this.homeYearList = this.sliceHomeYearList(this.homeYearList, 3)
                    }

                    this.$refs.yearpop && this.$refs.yearpop.doClose()
                }
            }, err => {
                this.$alert(err)
            })
        },
        sliceHomeYearList (array, len) {
            let result = []
            let tempLength = array.length

            for (let i = 0; i < tempLength; i += len) {
                result.push(array.slice(i, i + len))
            }

            return result
        },
        selYear (item) {
            if (this.nowYear != item) {
                this.nowYear = item
                this.getHomeYear()
            }
        },
        getPeList(){
            this.$http.post('/rest/api/dsp/sysevas/getEvasList',{page: {
                    pageNo: 1,
                    pageSize: 5,
                }}).then((res)=>{
                if (res.data.result) {
                    this.peList = res.data.value.list || [];
                }
            })
        },
        showInfoDetail(list){
        	if(!this.$root.stockId){
                this.$confirm('您尚未登录，请先登录后再查看！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
        			this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`);
                }).catch(() => {

                })
                return
        	}
	      	 this.checkShowDetail(v=>{
				this.$router.push(`/InviteInfo/${encodeURIComponent(list.fid)}`)
	      	 })
        },
        checkShowDetail(cb){
            return this.$http.post('/rest/api/supplierHomepage/getStockStep', this.$root.stockId).then(res => {
                const data = res.data;
                if (data.result) {
                    if(data.value!=3){
                    	this.$message({message: 'Error: 审核未通过，不能查看详情', type: 'error'})

                    }else{
                    	!!cb&&cb()
                    }
                } else {
                    this.$message({message: 'Error: 公告列表', type: 'error'})
                }
            })
        },

        toDetail(item){
            if(!item.id) return;
            this.$router.push({name:'NoticeInfo',params:{id:item.id}})
        }
    },
    created(){
        this.getCarousel()
        this.getInviteList()
        this.getWinInviteList()
        this.getGroupContent()
        this.getHomeYear()
        this.getPeList()
    },
    mounted () {

    }
}
</script>
<style lang="css" scoped>
@import 'Index.css';
</style>
<style scoped>
    @import '../assets/common.css';
    .year-supplier-box .el-row{
        padding: 10px 0;
    }
    .year-supplier-box .el-row .text-box{
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: #606060;
    }
    .year-supplier-box .el-row .hover-div{
        cursor: pointer;
    }
    .year-supplier-box .el-row .hover-div:hover{
        color: #F28718;
        text-decoration: underline;
    }
    .year-supplier-box .table-head{
        font-weight: bold;
        border-bottom: 1px solid #e6e6e6;
    }
    .clearfix:after {
        display: table;
        content: " ";
        clear: both;
    }
    .home {
        background-color: #f7f7f7;
        padding-bottom: 20px;
    }
    .home-ttl {
        font-weight: normal;
        font-size: 36px;
        text-align: center;
        color: #606060;
        padding: 0 0 20px 0;
        background: url("../assets/imgs/home_ttlbg.png") no-repeat bottom center;
    }
    .home-ttl .topic {
        font-size: 30px;
    }
    .container-center{
        margin: -140px auto 0;
    }
    .messagebox {
        position: relative;
        z-index: 2;
        box-shadow: 0 0 10px #E0E0E0;
        padding-top: 35px;
        margin: 0 auto 45px;
        background: #fff;
        font-size: 14px;
        color: #606060;
    }
    .messagebox .list-title {
        font-weight: bold;
        border-bottom: 1px solid #e6e6e6;
    }
    .messagebox .mlist {
        width: 980px;
        margin: 0 auto;
    }
    .messagebox .mlist .text-left {
        text-align: left;
    }
    .messagebox .mlist .cursorl {
        cursor: pointer;
    }
    .messagebox .mlist .cursorl:hover {
        color: var(--cMain);
    }
    .messagebox .mlist .grid-content {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .messagebox .mlist .padL210 {
        padding-left: 210px;
    }
    .messagebox .mlist .more-link {
        width: 78px;
        height: 28px;
        line-height: 28px;
        margin: 30px auto 0;
        font-size: 12px;
        color: #f38619;
        border: 1px solid #f38619;
        border-radius: 2px;
        cursor: pointer;
    }
    .messagebox .mlist .el-row {
        margin: 10px 0;
    }
    .card {
        padding: 50px 0 35px;
        text-align: center;
    }
    .tabcard {
        padding: 52px 0 0 279px;
        font-size: 14px;
        color: #606060;
    }
    .tabitem{
        float: left;
        width:148px;
        margin-left: 48px;
        line-height: 42px;
        text-align: center;
        border-radius: 44px;
        background: #fff;
        border: 1px solid #e6e6e6;
        box-shadow: 0 0 3px #e6e6e6;
    }
    .tabactive {
        box-shadow: none;
        color: #fff;
        border: 1px solid var(--mainColor);
        background: var(--mainColor);
    }
    .rankbox .box {
        padding: 40px 0;
        font-size: 16px;
        color: #606060;
    }
    .rankbox .rankimg {
        float: left;
        width: 540px;
    }
    .rankbox .ranklist {
        float: left;
        width: 660px;
    }
    .rankbox .title {
        padding: 0 70px 18px 25px;
        font-weight: bold;
        border-bottom: 1px solid #e6e6e6;
    }
    .rankbox .title span {
       float: right;
        display: inline-block;
    }
    .rankbox .company {
        min-height: 42px;
        padding: 32px 23px 32px 80px;
        text-align: right;
        border-bottom: 1px dashed #e7e7e7;
    }
    .rankbox .rank0 {
        background: url("../assets/imgs/home_rank01.png") no-repeat 10px center;
    }
    .rankbox .rank1 {
        background: url("../assets/imgs/home_rank02.png") no-repeat 10px center;
    }
    .rankbox .rank2 {
        background: url("../assets/imgs/home_rank03.png") no-repeat 10px center;
    }

    .notice-box-wrap{
        position: relative;
        z-index: 1000;
    }
    .notice-box-wrap .bid-box{
        padding:0 10px 10px 10px;
    }
    .notice-box-container{
        display:flex;
        flex-wrap: wrap;
        padding:10px;
    }
    .notice-box-container .notice-item{
        width:50%;
        height:32px;
        line-height: 32px;
    }
    .notice-box-wrap .title-text{
    }
</style>
<style>
    .home .el-carousel {
        min-width: 1200px;
    }
    .home .el-carousel__container {
        width: 100%;
        height: 549px;
    }
    .home .el-carousel__arrow{
        height: 56px;
        width: 56px;
        border: 3px solid #EE7D42;
        font-size: 30px;
        color: #EE7D42;
    }
    .home .el-carousel__button{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #EE7D42;
    }
    .el-popover--plain{
        padding: 0 !important;
    }
    .el-popover{
        padding: 0 !important;
        min-width: 0 !important;
    }
    .el-tabs__item{
        font-size: 18px;
        font-weight: 600;
        color: #333333;
    }
    .el-tabs__active-bar{
        height: 3px;
    }
    .el-tabs__header{
        margin: 0 0 30px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue